import './App.scss';
import Home from './components/Home';
import TrainingApp from './training/TrainingApp';
import GymApp from './gym/GymApp';
import { trainingSite, gymSite } from './training/runtime';
import React, { useEffect } from 'react';
import $ from 'jquery'
import Modal from './components/Modal';
import ShotReviewPage from './components/ShotReviewPage';

function App() {

  useEffect(() => {
    $('#mainDiv').fadeIn(700)
  }, [])

  if (trainingSite) return <TrainingApp />;
  if (gymSite) return <GymApp />;

  const reviewPage = typeof window !== 'undefined' && (
    window.location.pathname.replace(/\/$/, '') === '/xg-review'
    || new URLSearchParams(window.location.search).get('page') === 'xg-review'
  );
  if (reviewPage) return <ShotReviewPage />;

  return (
    <div id='mainDiv' className="container flexCol" style={{ display: 'none' }}>
      {/* Header removed per user request */}
      <div className="flexRow flexGrow">
        <Home />
        <Modal />
      </div>
    </div>
  );
}

export default App;
